<!--
  DistributorIntegrations -- the Suppliers page (Distributor App > Account >
  Suppliers): the distributor's supplier accounts.

  IA unit U1 (docs/planning/2026-10-19-distributor-setup-ia-proposal.md,
  D3 + Q10, Jake 2026-10-19): this page was "Integrations" and carried a
  Stripe Connect row beside the supplier rows. Stripe Connect now lives on
  Payments ONLY, so the Stripe row is no longer mounted here, and the page
  is titled Suppliers. The file keeps its name (renaming it is churn with no
  user-visible effect);
  the old StripeIntegration.vue wrapper was deleted by unit U2.

  History: moved out of Company Profile (where it was the second tab) onto
  its own Account page 2026-09-24 (Jake).

  CAPABILITY: the route is gated on `distributor.account.read` -- the same
  guard Company Profile carries, unchanged by the move or the rename.
-->
<template>
  <v-container data-testid="dist-integrations-page">
    <h1 class="md-header" data-testid="dist-suppliers-title">Suppliers</h1>
    <p class="md-lede" data-testid="dist-suppliers-purpose">
      Connect your supplier accounts so ThreadFlow can price, and where
      supported order, your blanks. You can build stores while these are
      pending.
    </p>
    <supplier-integrations />
  </v-container>
</template>

<script>
import SupplierIntegrations from "./SupplierIntegrations.vue";

export default {
  // Named so the route table can assert it mounts the real page rather
  // than a fallback frame (distributor-account-routes-port.spec.js skips
  // DistributorProfile for exactly the lack of this field).
  name: "DistributorIntegrations",

  components: {
    SupplierIntegrations,
  },
};
</script>
